export default function (msg: string): string {
    return msg ? msg.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '') : '';
}
